import { createApi } from '@reduxjs/toolkit/query/react';
import { searchHSN, SearchHSNQuery, SearchHSNQueryVariables } from '../../../graphql';
import { baseQuery } from '../../../utils';

type SearchHSNResponse = { label: string; value: string }[];

export const searchHSNApi = createApi({
  reducerPath: 'hsnApi',
  baseQuery,
  tagTypes: ['HSN'],
  endpoints: (builder) => ({
    searchHSN: builder.query<SearchHSNResponse, SearchHSNQueryVariables>({
      query: ({ rowfrom, word, limitno, codetype }) => ({
        body: searchHSN,
        variables: {
          rowfrom,
          limitno,
          word,
          codetype,
        },
      }),
      transformResponse: (response: SearchHSNQuery) => {
        return (
          response?.searchHSN?.map((item) => ({ 
            label: `${item?.hsnsaccode} - ${item?.description}`, 
            value: item?.hsnsaccode || '' // Use hsnsaccode as value
          })) ?? []
        );
      },
      providesTags: (result, error, { rowfrom, limitno, word, codetype }) => [
        { type: 'HSN', id: `${rowfrom}-${limitno}-${word}-${codetype}` },
      ],
      keepUnusedDataFor: 180,
    }),
  }),
});

export const { useSearchHSNQuery } = searchHSNApi;
